import React from "react";
import SimpleReactValidator from "simple-react-validator";
import Select from "react-select";

class ListForm extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        this.state = {
            ...this.props.listPro,
            submitted: false,
            formType: this.props.formTypePro || ""
        };
        this.handleList = this.handleList.bind(this);
        this.handleListSubmitForm = this.handleListSubmitForm.bind(this);
    }
    handleList(e) {
        const { name, value } = e.target;
        // const listState = { ...this.state.list };
        // listState[name] = value;
        this.setState(prevState => ({
            list: {
                ...prevState.list,
                [name]: value
            }
        }));
    }

    handleDropdown = (selectedOption, name) => {
        if (name.action === "select-option") {
            this.setState(
                {
                    list: {
                        ...this.state.list,
                        parent_id: selectedOption.id,
                        parent: selectedOption.title
                    }
                });
        }
    };

    handleListSubmitForm(e) {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            this.setState(
                {
                    submitted: true
                },
                function() {
                    this.props.handleListSubmit(
                        this.state.list,
                        this.state.formType
                    );
                }
            );
        } else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        const {  list } = this.state;
        const { parentData } = this.props;
        return (
            <form onSubmit={this.handleListSubmitForm}>
                {this.props.parent_id && (
                    <div className="flexElem fieldWithLabel alignFlexCenter">
                        <div>
                            <label htmlFor="name">
                                Select <span className="requiredClass">*</span>
                            </label>
                        </div>
                        <div
                            style={{ paddingBottom: "10px" }}
                            className="text-capitalize"
                        >
                            <Select
                                // value={HF.returnLabelWithValue(parentData.parent_id, parentData)}
                                value={
                                    parentData
                                        ? {
                                              id: this.state.list.parent_id,
                                              title: this.state.list.parent
                                          }
                                        : null
                                }
                                onChange={this.handleDropdown}
                                getOptionLabel={parentData => parentData.title}
                                getOptionValue={parentData => parentData.id}
                                options={this.props.parentData}
                                isSearchable={true}
                                isMulti={false}
                                placeholder={"Select"}
                                isClearable={false}
                            />
                            {/* {this.validatorState.message('countries', this.state.list.parent_id, 'required')} */}
                        </div>
                    </div>
                )}

                <div className="flexElem fieldWithLabel alignFlexCenter">
                    <div className="">
                        <label htmlFor="name">
                            Title<span className="requiredClass ">*</span>
                        </label>
                    </div>

                    <div>
                        <input
                            type="text"
                            name="title"
                            className="form-control text-capitalize"
                            value={this.props.listPro.list ? list.title : ""}
                            autoFocus={true}
                            onChange={this.handleList}
                        />
                        {/*this.valitdatorList.message('title', list.title, 'required|min:3') */}
                    </div>
                </div>

                <div className="text-center mt-xlg flexElem flex-center alignFlexCenter">
                    <button type="submit" className="customBtn btnBlue mr-sm">
                        Save
                    </button>
                    <button
                        type="button"
                        onClick={() => this.props.closeModel()}
                        className="customBtn btnBlack ml-sm"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        );
    }
}

export default ListForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Lists/ListForm.jsx